import { Typography, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1rem',
    fontWeight: 500,
    marginBottom: theme.spacing(2),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    marginBottom: theme.spacing(0.5),
    textTransform: 'uppercase',
  },
  value: {
    fontSize: 16,
  },
}));

const MainInfo = ({
  label,
  status,
  triggeredDate,
}: {
  label: string;
  status: string;
  triggeredDate: string;
}) => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.title}>{label}</Typography>
      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        <Grid item xs={6}>
          <Typography className={classes.label}>status</Typography>
          <Typography className={classes.value}>{status}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.label}>triggered</Typography>
          <Typography className={classes.value}>{triggeredDate}</Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default MainInfo;
